import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "truncate",
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, length: number = 10): string {
    if (value.length <= length) {
      return value;
    }

    const truncated = value.substr(0, length);
    const extension = value.split(".").pop();
    const suffix = "...";

    return `${truncated}${suffix}.${extension}`;
  }
}
